const radius = {
    md: '1rem',
    sm: '0.5rem',
    xs: '0.35rem'
}

export { radius }
